export const siteFormSchema = {
  type: 'object',
  required: ['name', 'projectNumber'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
    projectNumber: { type: 'string', minLength: 6, maxLength: 255 },
  },
};
